import React from 'react';
import {FaRegWindowClose} from 'react-icons/fa';

export const UserPunktePoPup = (
  {setIsPopUpVisible,
  newPoint,
  setNewPoint,
  districtName,
  saveChange}
) => {
  return (
    <div className='absolute top-1/3 '>
      <div className='w-72 h-64 shadow-inner  bg-white'>
        <div className='flex justify-end'>
          <div className='p-1'>
            <button
              onClick={() => {
                setIsPopUpVisible(false);
              }}
            >
              <FaRegWindowClose className='w-6 h-6' />
            </button>
          </div>
        </div>
        <div>
        <div className='font-bold w-full text-center'>{districtName}</div>
          <div className='h-32 flex items-center justify-center'>
            <div className='w-40 border-b-2 border-black text-center'>
              <p>PKT</p>
              <input
                type='number'
                placeholder='Eingeben PKT'
                className='bg-transparent text-center w-7/8'
                defaultValue={newPoint}
                onChange={(e) => {
                  setNewPoint(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className='text-center mt-1'>
          <button
            onClick={saveChange}
            className='shadow bg-blue-accent cursor-pointer hover:bg-blue-hover 
              focus:shadow-outline focus:outline-none text-white font-bold py-1 mb-1 px-3 rounded mx-auto'
          >
            Speichern
          </button>
        </div>
      </div>
    </div>
  );
};
